import { Controller } from "@hotwired/stimulus";

export default class RepeaterController extends Controller {
  static targets = ["container", "template", "item"];

  add() {
    this.containerTarget.appendChild(this.templateTarget.content.cloneNode(true));
  }

  remove(e) {
    e.currentTarget.closest("[data-repeater-target=item]")?.remove();
  }
}
